module.exports = __webpack_public_path__ + "img/logoPronaht.86905bb1.svg";